import { CookieConsentSelectors } from './state';
const selectors: CookieConsentSelectors = {};

export { selectors };
